import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiDatePicker, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ExportPDFButton from '../../pdf_table.js';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Table } from 'antd';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { getStorage, setStorage, updateFilterUrl, rupees } from "../../helper.js";
import { renderToStaticMarkup } from 'react-dom/server';



export default function Daybook() {
  let navigate = useNavigate();
  const location = useLocation();
  const [fy] = useOutletContext();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const parsed = queryString.parse(location.search);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);





  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    setValue,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])

    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'daybook', 1), { replace: location.search ? true : false })


  };





  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/daybook" + filter
    );

    var dataa = data;

    return dataa;

  }

  const defaultValues = {
    date: null,
  };



  useEffect(() => {
    queryClient.invalidateQueries(['daybook'])
  }, [fy]);


  useEffect(() => {

    if (location.search) {
    } else {
      setFilter(defaultValues)
    }




  }, [location]);



  useEffect(() => {


    const parsed = queryString.parse(location.search);



    setFilter(parsed)




  }, []);





  const { data, error, isError, isLoading, isFetching } = useQuery(["daybook", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
  });


  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        from: filter.from ? filter.from : data && data.from ? data.from : null,
        to: filter.to ? filter.to : data && data.to ? data.to : null,
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {


    if (data && data.from) {
      setValue('from', data.from)
      setValue('to', data.to)
    }

  }, [data]);




  const generatePDF = (types, period) => {
    const columns = [
      {
        title: 'No.',
        dataIndex: 'num',
        key: 'num',
        width: 15,
        colspan: 3
      },
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: 25,
      },
      {
        title: 'Party',
        dataIndex: 'particular',
        key: 'particular',
        width: 70,
        items: 1
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        align: 'right',
        width: 25
      },
      {
        title: 'Narration',
        dataIndex: 'narration',
        key: 'narration',
        width: 47
      },



    ];

    const lastbold = true

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = pageWidth / 2;
    var startY = 10;

    doc.setFontSize(12);
    doc.setFontSize(19);
    doc.text('Daybook', centerX, startY, { align: 'center' });
    startY = startY + 8
    doc.setFontSize(11);
    doc.text(period, centerX, startY, { align: 'center' });
    startY = startY + 10


    types.map((data1, i) => {




      if (doc.internal.pageSize.getHeight() < startY + 10) {

        doc.addPage();
        startY = 10
      }
      doc.setFontSize(16);
      doc.text(data1.type, centerX, startY, { align: 'center' });
      startY = startY + 10



      // Define the table column names
      const tableColumn = columns.map(col => col.title);

      // Define the table rows
      const tableRows = data1.data.map(item => columns.map(col => item[col.dataIndex]));

      // Map column alignment settings
      const columnStyles = columns.reduce((styles, col, index) => {
        styles[index] = {};

        // Handle alignment if specified
        if (col.align) {
          styles[index].halign = col.align;
        }

        // Handle width if specified, otherwise default to 'auto'
        styles[index].cellWidth = col.width || 'auto';

        return styles;
      }, {});

      // Add the table to the PDF
      doc.autoTable({
        startY: startY,
        head: [tableColumn],
        body: tableRows,
        theme: 'grid',

        willDrawCell: (data) => {
          // Check if this is the last row
          const isLastRow = data.row.index === data.table.body.length - 1;
          if (isLastRow && lastbold) {
            // Set font style to bold for the last row
            doc.setFont(undefined, 'bold');
          }
        },
        // Reset the font style to normal after drawing the table
        didDrawCell: (data) => {
          const isLastRow = data.row.index === data.table.body.length - 1;
          if (isLastRow && lastbold) {
            doc.setFont(undefined, 'normal');
          }
        },


        didParseCell: function (data) {
          const totalRows = data.table.body.length; // Total number of rows in the table
          const rowIndex = data.row.index;

          // Ensure multi-line text is split and processed correctly
          if (typeof data.cell.raw === 'string') {
            // Split text by newline
            data.cell.text = data.cell.raw.split('\\n').map(line => line.trim()); // Trim leading/trailing spaces
          }
          const column = columns[data.column.index];
          if (rowIndex === totalRows - 1) {
            if (column && column.colspan) {
              data.cell.colSpan = column.colspan;
              const nextColumns = columns.slice(data.column.index + 1, data.column.index + column.colspan);
              nextColumns.forEach((_, i) => {
                data.row.cells[data.column.index + i + 1].text = ''; // Clear text in the merged cells
              });
            }
          }



          if (data.section === 'body' && column.items == 1 && rowIndex != totalRows - 1) {
            const doc = data.doc;
            const lines = data.cell.raw.split('\\n');
            const cellWidth = column.width - 5;

            data.cell.text = lines.map(line => {
              const [desc, qty] = line.split('||');

              if (qty !== undefined) {
                // Trim text to avoid extra spaces
                const descText = desc.trim();
                const qtyText = qty.trim();

                // Get the width of each text
                const descWidth = doc.getTextWidth(descText);
                const qtyWidth = doc.getTextWidth(qtyText);

                // Calculate available width in the cell
                const availableWidth = cellWidth - qtyWidth;


                // Adjust padding to align description and quantity
                const padding = Math.max(0, availableWidth - descWidth);

                // Create the formatted line with padding
                return `${descText}${' '.repeat(Math.floor(padding))}${qtyText}`;
              } else {
                // Return line if there's no quantity
                return line;
              }
            });
          }

        },
        columnStyles: columnStyles,
        headStyles: {
          fillColor: [223, 234, 252],
          textColor: 0,
          fontStyle: 'bold',
          valign: 'middle', // vertical align
        },
      });
      startY = doc.lastAutoTable.finalY + 25;
    })


    // Save the PDF
    //doc.save(title+'.pdf');
    window.open(doc.output('bloburl', 'daybook.pdf'), '_blank');

  };



  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };








  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Daybook
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Daybook" >

            <UiButton className="btn btn-outline-primary" onClick={() => generatePDF(data.types, data.from + ' - ' + data.to)} title="PDF" />


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4 pb-4">
            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">

                <div className="row">

                  <div className="col-md-2">

                    <Controller

                      name="from"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="From"
                          onChange={onChange}
                          default_val={value}
                          message={errors.from?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

                  <div className="col-md-2">

                    <Controller

                      name="to"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="To"
                          onChange={onChange}
                          default_val={value}
                          message={errors.to?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>





                  <div className="col-md-1" style={{ paddingTop: '28px' }}>
                    <div className="d-flex justify-content-end">

                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>
            {data && data.company ? (
              <div className="table-responsive">
                <div className="p-3" id="printdiv" style={{ minWidth: '700px' }}>
                  <div className="position-relative d-block">
                    <div className="text-center mb-4">
                      <h1>{data.company}</h1>
                      <h2>Daybook</h2>
                      <p>{data.from} - {data.to}</p>

                    </div>

                    {data.types.map((item, index) => (

                      <div className="" key={index}>
                        <div className="text-center mb-4 mt-4">
                          <h3>{item.type}</h3>
                        </div>
                        <table className="table1 table-bordered w-100">
                          <colgroup>
                            <col width='30px' />
                            <col width='50px' />
                            <col width='200px' />
                            <col width='200px' />
                            <col width='70px' />
                            <col width='100px' />
                          </colgroup>
                          <thead>
                            <tr>
                              <th scope="col">No.</th>
                              <th scope="col">Date</th>
                              <th scope="col">Party</th>
                              <th scope="col">Details</th>
                              <th scope="col" className="text-end">Amount</th>
                              <th>Narration</th>
                            </tr>
                          </thead>

                          <tbody>

                            {item.data.map((item11, index11) => (
                              <tr key={index11}>
                                <td>{item11.num}</td>
                                <td>{item11.date}</td>
                                <td>{item11.party}</td>
                                <td>
                                  {item11.entries && item11.entries.map((item1, index1) => (
                                    <div className="d-flex justify-content-between" key={index1}><span>{item1[0]}</span><span>{item1[1]}</span></div>
                                  ))}
                                </td>
                                <td className="text-end">{rupees(item11.amount)}</td>
                                <td>{item11.narration}</td>
                              </tr>
                            ))}
                          </tbody>


                        </table>
                      </div>
                    ))}



                  </div>
                </div>
              </div>
            ) : <BgLoader />}









          </div>
        </div>
      </div>
    </>
  );
}
